export const ERROR_CODE = '404';
export const ERROR_TEXT = 'WE ARE SORRY, PAGE NOT FOUND!';
export const LINK_TEXT = 'Back To Homepage';
